import holidayApi from '../../api/holiday'

const actions = {
  getAll ({ commit }) {
    return new Promise((resolve, reject) => {
      holidayApi.getAll(holidays => {
        resolve(holidays)
      },
      error => {
        reject(error)
      })
    })
  },

  create ({ commit }, params) {
    return new Promise((resolve, reject) => {
      holidayApi.create(params, holiday => {
        resolve(holiday)
      },
      err => {
        reject(err)
      })
    })
  },

  delete ({ commit }, id) {
    return new Promise((resolve, reject) => {
      holidayApi.delete(id, holiday => {
        resolve(holiday)
      },
      err => {
        reject(err)
      })
    })
  }
}

export default {
  namespaced: true,
  //getters,
  actions,
  // state,
  // mutations
}
